import { render, staticRenderFns } from "./AyudasEmprendedor.vue?vue&type=template&id=3754217c&scoped=true&"
var script = {}
import style0 from "./AyudasEmprendedor.vue?vue&type=style&index=0&id=3754217c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754217c",
  null
  
)

export default component.exports